<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="mallConsumablesRef"></wt-form-table>
    <!-- 编辑 -->
    <MallConsumablesEditPage :visible.sync="formDialogVisible" :formData="formData" @refreshData="$refs.mallConsumablesRef.requestFormList()"></MallConsumablesEditPage>
  </div>
</template>

<script>
export default {
  name: 'MallConsumablesIndex',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_MALL_CONSUMABLES',
        formComponent: {
          view: { type: 'component', componentName: 'MallConsumablesView', noRequest: true },
          list: { type: 'default', value: '/modules/consumables/consumablesList' },
          delete: { type: 'default', value: '/modules/consumables/consumablesDelete' }
        },
        formInputsData: [],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '库存清零', key: 'CLEAR', action: 'CLEAR', hidden: false, permission: 'CLEAR' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '耗材类型', key: 'name', type: 'text' },
          { name: '库存数', key: 'inventory', type: 'text' },
          { name: '备注', key: 'remark', type: 'text' },
          { name: '操作人', key: 'operateUserName', type: 'text' },
          { name: '操作时间', key: 'updateTime', type: 'text' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      },
      formDialogVisible: false,
      formData: {}
    }
  },
  methods: {
    onButtonAction(data) {
      const that = this
      if (data && data.item) {
        if (data.item.action === 'ADD') { // 新增
          this.formData = {}
          this.formDialogVisible = true
        }
        if (data.item.action === 'EDIT') {
          this.formData = JSON.parse(JSON.stringify(data.row))
          this.formData.inventoryorg = data.row.inventory
          this.formDialogVisible = true
        }
        if (data.item.action === 'CLEAR') { // 清空
          if (this.form.formSelectedList && this.form.formSelectedList.length > 0) {
            this.$confirm('确定库存清零？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const dataIdList = []
              that.form.formSelectedList.forEach((item) => {
                dataIdList.push(item.id)
              })
              that.$api.mall.consumables.consumablesClearInventory({
                list: dataIdList
              }).then(res => {
                that.$message({ message: '操作成功', type: 'success' })
                that.$refs.mallConsumablesRef.requestFormList()
              })
            })
          } else {
            this.$alert('请选中至少一列数据', '提示', {
              type: 'error',
              confirmButtonText: '确定'
            }).then(() => {}).catch(() => {})
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
